import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(timezone);

export const DEFAULT_TIMEZONE = 'America/New_York';
export const DATE_FORMAT = 'DD-MMM-YYYY';
export const DATE_TIME_FORMAT = 'DD-MMM-YYYY h:mm a';
export const DATE_FORMAT_NUMERICAL = 'DD/MM/YYYY';
export const APOLLO_DATE_FORMAT = 'YYYY-MM-DD';
export const TERMS_AND_CONDITIONS = [
  {
    key: 'privacy-policy',
    descriptions:
      'I attest that Privacy Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam'
  },
  {
    key: 'terms-of-service',
    descriptions:
      'I attest that Privacy Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam'
  },
  {
    key: 'gdpr-policy',
    descriptions:
      'I attest that Privacy Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam'
  }
];

// check if the current environment is storybook
export const IsInStorybookEnv = () => {
  return (window.location.hostname === 'localhost' && window.location.port === '6006') || window.location.hostname.includes('chromatic.com');
};

export const FormatTimeCounter = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
};

export const GENDERS = [
  { label: 'Male', value: 'M' },
  { label: 'Female', value: 'F' },
  { label: 'X', value: 'X' }
];

export const FormatDate = (dateStr: string | Date = '', dateFormat?: string) => {
  return dateStr ? dayjs(dateStr).tz(DEFAULT_TIMEZONE).format(dateFormat ?? DATE_FORMAT).toUpperCase() : '';
};

export const CaseState = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  CASE_WORKER_ASSIGNED: 'caseWorkerAssigned',
  REVISION_REQUESTED: 'revisionRequested',
  REVISION_SUBMITTED: 'revisionSubmitted',
  DECISION_RENDERED: 'decisionRendered'
};

export const IdCaseFileUploadSpec = {
  Passport: {
    // maxFileSize: 2 * 1024 * 1024,
    permittedContentTypes: ['image/jpeg', 'image/png'],
    permittedExtensions: ['jpg', 'jpeg', 'png'],
    fileName: 'passport.jpg',
    fieldName: 'passport'
  },
  PassportExpirationPage: {
    // maxFileSize: 2 * 1024 * 1024,
    permittedContentTypes: ['image/jpeg', 'image/png', 'application/pdf'],
    permittedExtensions: ['jpg', 'jpeg', 'png', 'pdf'],
    fileName: 'passport-expiration-page',
    fieldName: 'passportExpiration'
  },
  PassportTranslation: {
    // maxFileSize: 2 * 1024 * 1024,
    permittedContentTypes: ['application/pdf'],
    permittedExtensions: ['pdf'],
    fileName: 'passport-translation.pdf',
    fieldName: 'passportTranslation'
  },
  Photo: {
    // maxFileSize: 2 * 1024 * 1024,
    permittedContentTypes: ['image/jpeg', 'image/png'],
    permittedExtensions: ['jpg', 'jpeg', 'png'],
    fileName: 'photo.jpg',
    fieldName: 'photo'
  },
  NotarizedIdForm: {
    // maxFileSize: 2 * 1024 * 1024,
    permittedContentTypes: ['application/pdf'],
    permittedExtensions: ['pdf'],
    fileName: 'id-form-notarized.pdf',
    fieldName: 'notarizedIdForm'
  }
};
